import * as React from 'react';
import { connect } from 'react-redux';
import { Sidebar, Properties } from '../components';
import { IComponent, FeatureHelper, IProperty, EConfirmationOperationType, EComponentTypes } from '../helpers';
import { Panel, PanelType, Button, Toggle, Dropdown, Checkbox } from 'office-ui-fabric-react';
import store from '../store/store';
import types from '../store/types';

declare var jQuery;

class SettingsContainer extends React.Component<any, any> {

    public componentDidUpdate() {
        jQuery('.shared-journey-info').tooltip();
    }

    private updateProperty = (name: string, val: any): void => {
        store.dispatch({
            type: types.UPDATE_JOURNEY_PROPERTY,
            name: name,
            value: val
        });
    }

    sharedJourneyCheckboxStatus = (isSharedJourney: boolean, isTriageJourney: boolean, sharedJourneyComponentCount: number) => {

        if (sharedJourneyComponentCount > 0) {
            return true;
        }

        if (isSharedJourney === false && isTriageJourney !== true) {
            return false;
        } else if (isSharedJourney === true && isTriageJourney !== true) {
            return true;
        } else if (isSharedJourney === false && isTriageJourney === true) {
            return true;
        } else {
            //console.log("ERROR with shared journey checkbox - " + isSharedJourney + isTriageJourney);
        }
    }

    triageJourneyCheckboxStatus = (isSharedJourney: boolean, isTriageJourney: boolean) => {
        if (isSharedJourney === false && isTriageJourney !== true) {
            return false;
        } else if (isSharedJourney === true && isTriageJourney !== true) {
            return true;
        } else if (isSharedJourney === false && isTriageJourney === true) {
            return false;
        } else {
            //console.log("ERROR with triage journey checkbox- " + isSharedJourney + isTriageJourney);
        }
    }

    pageJourneyCheckboxStatus = (isPageJourney: boolean) => {
        return false;
    }

    replaceGuidsCheckboxStatus = (isSharedJourney: boolean) => {

        return !isSharedJourney;
    }
    saveAndResumeCheckboxStatus = (isSaveAndResume: boolean) => {

        return !isSaveAndResume;
    }

    public render() {
        let { state, experimental, properties, isSharedJourney, isTriageJourney, isPageJourney, hideSteps, replaceGuids, isSaveAndResume, sharedJourneyComponentCount } = this.props;

        let propButtonStyles = {
            width: '100%'
        };

        let disableOrEnableSharedJourneyCheckbox = this.sharedJourneyCheckboxStatus(isSharedJourney, isTriageJourney, sharedJourneyComponentCount);
        let disableOrEnableTriageJourneyCheckbox = this.triageJourneyCheckboxStatus(isSharedJourney, isTriageJourney);
        let disableOrEnablePageJourneyCheckbox = this.pageJourneyCheckboxStatus(isPageJourney);
        let disableOrEnableReplaceGuidsCheckbox = this.replaceGuidsCheckboxStatus(isSharedJourney);
        let disableOrEnableSaveAndResumeCheckbox = this.saveAndResumeCheckboxStatus(isSaveAndResume);

        let sharedJourneyTooltip = `<p style='text-align: left;'>This journey contains a reference to a Shared Journey. Please remove this reference in order to make this journey a Shared Journey</p>`;

        return (
            <Panel
                className={"sidebar " + (true ? 'pinned' : '')}
                isOpen={state.isOpen}
                onDismiss={() => toggle()}
                type={PanelType.smallFixedFar}
                headerText={"Settings"}
                headerClassName={"step"}
                isLightDismiss={true}>

                {FeatureHelper.Supports('print_mode', this.props.features) && <div><Button style={propButtonStyles} onClick={() => { this.props.dispatch({ type: "SET_PAGE", page: "print" }); }}>Journey Overview</Button></div>}
                {FeatureHelper.Supports('print_mode', this.props.features) && <div><Button style={propButtonStyles} onClick={() => { this.props.dispatch({ type: "SET_PAGE", page: "upgrade" }); }}>Admin Tool</Button></div>}
                {
                    !!properties
                    && properties.length > 0
                    && <div>
                        <h2>Properties</h2>
                        <Properties
                            properties={properties}
                            primaryOnly={false}
                            change={(n, v, c) => this.updateProperty(n, v)}
                            componentId={null}
                        />
                    </div>
                }

                {
                    <div>
                        <Checkbox label="Shared Journey?" className="shared-journey horizontal-label" checked={isSharedJourney}
                            disabled={disableOrEnableSharedJourneyCheckbox}
                            onChange={(ev: React.FormEvent<HTMLInputElement>, checked: boolean) => { updateSharedJourney(checked); }} />
                        {(sharedJourneyComponentCount > 0) && <i className="ms-Icon ms-Icon--Info x-hidden-focus shared-journey-info"
                            title={sharedJourneyTooltip} aria-hidden="true" data-toggle="tooltip" data-placement="top" data-html="true">
                        </i>}
                    </div>
                }
                {
                    <div>
                        <Checkbox label="Triage Journey?" className="triage-journey horizontal-label" checked={isTriageJourney}
                            disabled={disableOrEnableTriageJourneyCheckbox}
                            onChange={(ev: React.FormEvent<HTMLInputElement>, checked: boolean) => { updateTriageJourney(checked); }} />
                    </div>
                }
                {
                    <div>
                        <Checkbox label="Page Journey?" className="paged-journey horizontal-label" checked={isPageJourney}
                            disabled={disableOrEnablePageJourneyCheckbox}
                            onChange={(ev: React.FormEvent<HTMLInputElement>, checked: boolean) => { updatePageJourney(checked); }} />
                    </div>
                }
                {
                    <div>
                        <Checkbox label="Hide Steps?" className="hide-steps horizontal-label" checked={hideSteps}
                            disabled={disableOrEnablePageJourneyCheckbox}
                            onChange={(ev: React.FormEvent<HTMLInputElement>, checked: boolean) => { updateHideSteps(checked); }} />
                    </div>
                }
                {
                    <div>
                        <Checkbox label="Replace Guids?" className="replace-guids horizontal-label" checked={replaceGuids}
                            disabled={disableOrEnableReplaceGuidsCheckbox}
                            onChange={(ev: React.FormEvent<HTMLInputElement>, checked: boolean) => { updateReplaceGuids(checked); }} />
                    </div>
                }
                {
                    <div>
                        <Checkbox label="Enable Save and Resume?" className="save-and-resume horizontal-label" checked={isSaveAndResume}
                            onChange={(ev: React.FormEvent<HTMLInputElement>, checked: boolean) => { updateSaveAndResume(checked); }} />
                    </div>
                }

                <div>
                    {experimental &&
                        <div>
                            <h2>Experimental Features</h2>
                            <Toggle label={"Enable Night Mode"} onChanged={(enabled) => {
                                if (enabled) {
                                    document.body.classList.add("theme--dark");
                                    this.props.dispatch({ type: "ENABLE_FEATURE", feature: "dark_theme", enabled: true });
                                }
                                else {
                                    document.body.classList.remove("theme--dark");
                                    this.props.dispatch({ type: "ENABLE_FEATURE", feature: "dark_theme", enabled: false });
                                }
                            }} defaultChecked={FeatureHelper.Supports("dark_theme", this.props.features)} />

                            <div>
                                {
                                    FeatureHelper.Supports('default_global_outputs', this.props.features) &&
                                    <Button onClick={() => { alert("Show default settings modal") }}>Set Default Global Outputs</Button>
                                }

                            </div>
                        </div>
                    }
                </div>

            </Panel>
        );
    }

};

let updateSharedJourney = (isSharedJourney: boolean) => {

    store.dispatch({
        type: types.TOGGLE_CONFIRMATION_DIALOG,
        operationType: EConfirmationOperationType.SetSharedJourney,
        title: 'Confirm Shared Journey',
        message: 'Click OK to confirm that you would like to make this journey a Shared Journey. This process is irreversible.',
        isOpen: true,
        okButtonLabel: 'OK',
        cancelButtonLabel: 'Cancel',
    });

};

let updateTriageJourney = (isTriageJourney: boolean) => {
    if (isTriageJourney === true) {
        store.dispatch({
            type: types.TOGGLE_CONFIRMATION_DIALOG,
            operationType: EConfirmationOperationType.SetTriageJourney,
            title: 'Confirm Triage Journey',
            message: 'Click OK to confirm that you would like to make this journey a Triage Journey. This process can be reversed.',
            isOpen: true,
            okButtonLabel: 'OK',
            cancelButtonLabel: 'Cancel',
        });
    } else {
        store.dispatch({
            type: types.TOGGLE_CONFIRMATION_DIALOG,
            operationType: EConfirmationOperationType.uncheckTriageJourney,
            title: 'Confirm Normal Journey',
            message: 'Clicking OK will revert this journey from a Triage Journey to a Normal Journey.',
            isOpen: true,
            okButtonLabel: 'OK',
            cancelButtonLabel: 'Cancel',
        });
    }
};

let updatePageJourney = (isPageJourney: boolean) => {
    if (isPageJourney === true) {
        store.dispatch({
            type: types.TOGGLE_CONFIRMATION_DIALOG,
            operationType: EConfirmationOperationType.SetPageJourney,
            title: 'Confirm Page Journey',
            message: 'Click OK to confirm that you would like to make this journey a Page Journey. This process can be reversed.',
            isOpen: true,
            okButtonLabel: 'OK',
            cancelButtonLabel: 'Cancel',
        });
    } else {
        store.dispatch({
            type: types.TOGGLE_CONFIRMATION_DIALOG,
            operationType: EConfirmationOperationType.uncheckPageJourney,
            title: 'Confirm Normal Journey',
            message: 'Clicking OK will revert this journey from a Page Journey to a Normal Journey.',
            isOpen: true,
            okButtonLabel: 'OK',
            cancelButtonLabel: 'Cancel',
        });
    }
};

let updateHideSteps = (hideSteps: boolean) => {
    if (hideSteps === true) {
        store.dispatch({
            type: types.TOGGLE_CONFIRMATION_DIALOG,
            operationType: EConfirmationOperationType.SetHideSteps,
            title: 'Confirm Page Journey',
            message: 'Click OK to confirm that you would like to hide steps for this journey. This process can be reversed.',
            isOpen: true,
            okButtonLabel: 'OK',
            cancelButtonLabel: 'Cancel',
        });
    } else {
        store.dispatch({
            type: types.TOGGLE_CONFIRMATION_DIALOG,
            operationType: EConfirmationOperationType.uncheckHideSteps,
            title: 'Confirm Normal Journey',
            message: 'Clicking OK will show the steps for this journey.',
            isOpen: true,
            okButtonLabel: 'OK',
            cancelButtonLabel: 'Cancel',
        });
    }
}
let updateReplaceGuids = (replaceGuids: boolean) => {
    if (replaceGuids === true) {
        store.dispatch({
            type: types.TOGGLE_CONFIRMATION_DIALOG,
            operationType: EConfirmationOperationType.setRepalceGuids,
            title: 'Confirm Replace Guids',
            message: 'Click OK to confirm that you would like to replace Guids for this journey. This process can be reversed.',
            isOpen: true,
            okButtonLabel: 'OK',
            cancelButtonLabel: 'Cancel',
            replaceGuids: true
        });
    } else {
        store.dispatch({
            type: types.TOGGLE_CONFIRMATION_DIALOG,
            operationType: EConfirmationOperationType.setRepalceGuids,
            title: 'Confirm Replace Guids',
            message: 'Clicking OK will not replace Guids for this journey.',
            isOpen: true,
            okButtonLabel: 'OK',
            cancelButtonLabel: 'Cancel',
            replaceGuids: false
        });
    }
};

let updateSaveAndResume = (saveAndResume: boolean) => {
    if (saveAndResume === true) {
        store.dispatch({
            type: types.TOGGLE_CONFIRMATION_DIALOG,
            operationType: EConfirmationOperationType.setSaveAndResume,
            title: 'Confirm Save and Resume',
            message: 'Click OK to confirm that you would like to enable Save-and-Resume for this journey. This process can be reversed.',
            isOpen: true,
            okButtonLabel: 'OK',
            cancelButtonLabel: 'Cancel',
            saveAndResume: true
        });
    } else {
        store.dispatch({
            type: types.TOGGLE_CONFIRMATION_DIALOG,
            operationType: EConfirmationOperationType.setSaveAndResume,
            title: 'Confirm Replace Guids',
            message: 'Clicking OK will disable Save-and-Resume for this journey.',
            isOpen: true,
            okButtonLabel: 'OK',
            cancelButtonLabel: 'Cancel',
            saveAndResume: false
        });
    }
};

let toggle = () => {
    store.dispatch({ type: types.TOGGLE_SETTINGS_SIDEBAR });
};

let mapStateToProps = (store) => {
    return {
        state: store.settingsState,
        features: store.toolsState.features,
        properties: store.toolsState.Properties,
        experimental: store.toolsState.experimentalFeaturesEnabled,
        isSharedJourney: store.toolsState.isSharedJourney,
        isTriageJourney: store.toolsState.isTriageJourney,
        isPageJourney: store.toolsState.isPageJourney,
        hideSteps: store.toolsState.hideSteps,
        replaceGuids: store.toolsState.replaceGuids,
        isSaveAndResume: store.toolsState.isSaveAndResume,
        sharedJourneyComponentCount: store.processState.sharedJourneyComponentCount
    };
};

export default connect<any, any, any>(mapStateToProps)(SettingsContainer);


// WEBPACK FOOTER //
// ./source/ts/containers/settings.tsx